import { useNavigate } from 'react-router-dom';
import { DashboardLayoutContainer } from 'components/Layouts/DashboardLayout';
import { Box } from '@mui/material';
import { GlobalUXState } from 'components/GlobalUXState';

export const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayoutContainer>
      <Box display="flex" justifyContent="center" paddingTop="40px">
        <GlobalUXState
          variant="accessDenied"
          actionLabel="Back to dashboard"
          onAction={() => navigate('/dashboard')}
        />
      </Box>
    </DashboardLayoutContainer>
  );
};
